import { render, staticRenderFns } from "./BuildHealth.vue?vue&type=template&id=3aeb057e"
import script from "./BuildHealth.vue?vue&type=script&lang=js"
export * from "./BuildHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports